import(/* webpackMode: "eager" */ "/vercel/path0/public-site/app/page.tsx");
